/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_ROUTES, GET_ROUTES } from 'src/actions/routeActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const routeReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ROUTES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_ROUTES: {
      const { items, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = items;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default:
      return state;
  }
};

export default routeReducer;
